export const configUseQuery = {
  refetchOnWindowFocus: false,
  refetchInterval: false,
};
